export default "__VITE_ASSET__BEB28EXJ__"